<template>
	<div class="page pageContainer">
		<div style="text-align: right; padding: 10px;">
			<el-button type="primary" @click="addPro()" size="mini">添加城市</el-button>
		</div>
		<el-table :data="DataList" style="width: 100%;margin-bottom: 20px;" row-key="id" border stripe
                  default-expand-all :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                  row-class-name="table-rowClass">
			<el-table-column type="index" label="序号" width="80">
			</el-table-column>
			<el-table-column prop="area_name" label="区域名称" min-width="180">
			</el-table-column>
			<el-table-column prop="area_code" label="区域代码" min-width="180">
			</el-table-column>
			<el-table-column prop="sort" label="排序号" width="80">

				<template slot-scope="scope">
					<span style="cursor: pointer;" @click="setSort(scope.row)" v-if="editId!=scope.row.id">{{scope.row.sort}}</span>
					<el-input v-else size="mini" v-model="editSort" @blur="saveSort"></el-input>
				</template>
			</el-table-column>
			<el-table-column fixed="right" label="操作" width="150">
				<template slot-scope="scope">



					<el-button type="text"
                               v-if="scope.row.pid==0"
                               @click="addSub(scope.row)" size="small">添加区域</el-button>

					<el-button type="text" style="color: orangered;" @click="deleteItem(scope.row)" size="small">删除</el-button>

				</template>
			</el-table-column>
		</el-table>


		<el-dialog title="添加区域" :visible.sync="dialogVisible" width="800" :close-on-click-modal="false">

			<el-form :model="EditItem" inline>
				<el-row>
					<el-form-item label="区域名称">
						<el-input placeholder="请输入区域名称" v-model="EditItem.area_name">
					
						</el-input>
					
					</el-form-item>
					
					<el-form-item label="区域编码">
						<el-input placeholder="请输入区域编码" v-model="EditItem.area_code">
					
						</el-input>
					
					</el-form-item>
					
					<el-form-item label="排序号">
						<el-input placeholder="请输入排序号" v-model="EditItem.sort">
					
						</el-input>
					
					</el-form-item>
					
				</el-row>

				

			</el-form>


			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="saveArea">保 存</el-button>
			</div>

		</el-dialog>

	</div>
</template>

<script>
	import {
		regionData,
		CodeToText
	} from "element-china-area-data";
	export default {

		data() {
			return {

				DataList: [],
				dialogVisible: false,
				EditItem: {
					id: "",
					area_name: "",
					area_code: "",
					pid: "",
					sort: "99",

				},
				datatype: "pro",
				parentName: "",
				provence: [],
				citys: [],

				proValue: "",

				cityValue: "",
				editId: 0,
				editSort: 0,
				editSortItem: null


			}
		},

		mounted() {
			this.query();

			this.provence = regionData

		},
		methods: {


			query() {

				this.$http.post('/api/sys_area_list', {}).then(res => {

					this.DataList = res.data;

				});
			},
			setSort(item) {
				this.editId = item.id;
				this.editSort = item.sort;
				this.editSortItem = item;
			},
			saveSort() {

				this.editSortItem.sort = this.editSort;
				this.$http.post('/api/sys_area_edit', this.editSortItem).then(res => {
					this.$message({
						type: 'success',
						message: '修改成功'
					});

					this.editId = 0;
					this.editSort = 0;
					this.query()
				});
			},
			addSub(item) {
				this.datatype = "city"
				this.EditItem = {
					id: "",
					area_name: "",
					area_code: "",
					pid: item.id,
					sort: "99",
				}
				this.proValue = item.area_code

				for (let p of this.provence) {
					if (p.value == item.area_code) {
						this.citys = p.children
						break
					}
				}


				this.dialogVisible = true;
			},
			addPro() {
				this.datatype = "pro"
				this.dialogVisible = true;
				this.proValue = "";
				this.EditItem = {
					id: "",
					area_name: "",
					area_code: "",
					pid: 0,
					sort: "99",
				}
			},

			saveArea() {
				if (this.datatype == "pro") {

					//省份
					for (let item of this.provence) {
						if (item.value == this.proValue) {
							this.EditItem.area_name = item.label;
							this.EditItem.area_code = item.value;
							break
						}
					}
				} else {
					for (let item of this.citys) {
						if (item.value == this.cityValue) {
							this.EditItem.area_name = item.label;
							this.EditItem.area_code = item.value;
							break
						}
					}
				}

				if (!this.EditItem.area_code) {
					this.$message({
						type: 'error',
						message: '请选择区域'
					});
					return
				}






				this.$http.post('/api/sys_area_edit', this.EditItem).then(res => {
					this.$message({
						type: 'success',
						message: '保存成功'
					});
					this.query();
					this.dialogVisible = false


				});
			},

			deleteItem(item) {
				this.clkbtn = true;
				setTimeout(() => {
					this.clkbtn = false;
				}, 300)
				this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post("/api/sys_area_delete", {
						id: item.id
					}).then(res => {
						this.$message({
							type: 'success',
							message: '删除成功'
						});

						this.query();
					})

				}).catch(() => {

				});
			}
		}
	}
</script>
<style type="text/less" lang="less">
    .table-rowClass{
        td{
            padding: 0!important;
        }
    }
</style>
<style scoped>
	.custom-tree-node {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
		padding-right: 8px;
	}
</style>
